<div class="loading" i18n></div>
